export default {"src":"/_next/static/media/section-adornment2-d.1462fd8e.svg","height":115,"width":1920,"blurWidth":0,"blurHeight":0};